import { DropdownItem, Grid, TextInput } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import ActionButtons from 'components/Filters/ActionButtons'
import Decimal from 'decimal.js'
import { NumericFormat } from 'react-number-format'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'

const FromToSelector = ({ filterManager, onApply, name }) => {
  const breakpoints = useBreakpoint()
  const { filters, configuration } = filterManager
  const { t } = useTranslation()

  const {
    nameFrom,
    nameTo,
    unit,
    placeholder = { from: undefined, to: undefined },
  } = configuration[name]

  const [from, setFrom] = useState(filters[nameFrom])
  const [to, setTo] = useState(filters[nameTo])

  const applyValues = useCallback(
    () =>
      onApply([
        { fieldName: nameFrom, value: from },
        { fieldName: nameTo, value: to },
      ]),
    [nameFrom, nameTo, from, to],
  )

  return (
    <>
      <DropdownItem noHover>
        <Grid wrap={false} alignItems={'center'} gap={4}>
          <NumericFormat
            value={from}
            placeholder={t(placeholder.from)}
            isAllowed={({ value }) => {
              if (!value) {
                return true
              } else {
                const floatVal = new Decimal(value)
                return (
                  floatVal.greaterThan('0.00') &&
                  floatVal.lessThanOrEqualTo('1000000000.00')
                )
              }
            }}
            customInput={TextInput}
            thousandSeparator={' '}
            allowLeadingZeros={true}
            decimalScale={2}
            decimalSeparator={'.'}
            fixedDecimalScale
            size={!breakpoints.md ? 's' : 'm'}
            onChange={(e) => {
              setFrom(Math.abs(parseFloat(e.target.value.replace(/\s/g, ''))))
            }}
            valueIsNumericString={true}
            // suffix={unit}
          />
          —
          <NumericFormat
            value={to}
            placeholder={t(placeholder.to)}
            isAllowed={({ value }) => {
              if (!value) {
                return true
              } else {
                const floatVal = new Decimal(value)
                return (
                  floatVal.greaterThan('0.00') &&
                  floatVal.lessThanOrEqualTo('1000000000.00')
                )
              }
            }}
            customInput={TextInput}
            thousandSeparator={' '}
            allowLeadingZeros={true}
            decimalScale={2}
            decimalSeparator={'.'}
            fixedDecimalScale
            size={!breakpoints.md ? 's' : 'm'}
            onChange={(e) => {
              setTo(Math.abs(parseFloat(e.target.value.replace(/\s/g, ''))))
            }}
            valueIsNumericString={true}
            // suffix={unit}
          />
          <span>{unit}</span>
        </Grid>
      </DropdownItem>
      <ActionButtons
        dropFilter={() => {
          setFrom('')
          setTo('')
        }}
        applyValue={() => {
          setFrom(from)
          setTo(to)
          applyValues()
        }}
      />
    </>
  )
}

FromToSelector.propTypes = {
  filterManager: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  optionLabelPrefix: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  onApply: PropTypes.func,
  onSelect: PropTypes.func,
  showActionButtons: PropTypes.bool,
  defaultValue: PropTypes.any,
  lock: PropTypes.bool,
  nameFrom: PropTypes.string,
  nameTo: PropTypes.string,
}

export default FromToSelector
